import { useCallback, useMemo } from 'react';
import { TableConfigDto } from '@asset-metrix/portal-gateway-client-js';
import { useDisclosure } from '@mantine/hooks';

import { invalidateTable } from '../../utils/queryCacheHelper';

import { DataIngestionModalProps } from './DataIngestionModal';

export type UseDataIngestionModalPropertiesReturnValue = {
  dataIngestionModalProps?: DataIngestionModalProps;
  open: () => void;
};

export function useDataIngestionModalProperties(
  pageId: string,
  contentId: string,
  config: TableConfigDto,
  instanceId: string
): UseDataIngestionModalPropertiesReturnValue {
  const [isOpen, { open, close }] = useDisclosure();
  const onUploadSuccess = useCallback(
    () => invalidateTable(config.cacheKey, pageId, contentId),
    [config.cacheKey, pageId, contentId]
  );

  const dataIngestionModalProps = useMemo<
    DataIngestionModalProps | undefined
  >(() => {
    if (config.createRowConfig?.type !== 'dataIngestion') {
      return undefined;
    }

    if (!isOpen) {
      return undefined;
    }

    return {
      onUploadSuccess,
      onClose: close,
      opened: isOpen,
      config: config.createRowConfig,
      contentId,
      instanceId,
    };
  }, [
    config.createRowConfig,
    isOpen,
    close,
    contentId,
    instanceId,
    onUploadSuccess,
  ]);

  return {
    open,
    dataIngestionModalProps,
  };
}
